import React, { useEffect, useState } from 'react'
import TextField from '../../../components/Forms/TextField'
import MainButton from '../../../components/templates/MainButton'
import styles from './register.module.scss'
import authStyles from '../auth.module.scss'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import ImageField from '../../../components/Forms/ImageField';
import { IMAGE_FORMATS } from '../../../utils/helpers/fileFormats';
import authService from '../../../axios/services/authService'
import { useDispatch } from "react-redux";
import { authActions } from '../../../redux/actions/authActions'
import useWindowSize from '../../../components/hooks/useWindowSize'
import { useToasts } from 'react-toast-notifications'
import SelectField from '../../../components/Forms/SelectField'
import Checkbox from '../../../components/Forms/Checkbox'

const schema = yup.object().shape({
  logo: yup.mixed()
    .test(
      "required",
      "Cover is Required",
      value => value.length > 0
    )
    .test(
      "fileFormat",
      "Unsupported Format",
      value => value?.[0] ? IMAGE_FORMATS.includes(value[0].type) : true
    ),
  name: yup.string().required('Nama perusahaan tidak boleh kosong'),
  title: yup.string().required('Jabatan tidak boleh kosong'),
  code: yup.string().required('Kode perusahaan tidak boleh kosong')
})

const StepSix = ({ data, setLoading }) => {
  const { width } = useWindowSize()
  const { register, handleSubmit, errors, watch, formState: { isValid }, setValue, unregister } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      code: ''
    }
  });
  const { logo, name, title, code } = watch(["logo", "name", "department", "title", "code"])
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [department, setDepartment] = useState()
  const [badanUsaha, setBadanUsaha] = useState()

  const [generatingCode, setGeneratingCode] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const [agree, setAgree] = useState(false)

  useEffect(() => {
    register('code')
    return () => {
      unregister('code')
    }
  }, [register, unregister])

  useEffect(() => {
    if (name?.length >= 3 && !code) {
      setGeneratingCode(true)
      setValue('code', name.substring(0, 3).toUpperCase().replace(/ /g, "_") + Math.floor((Math.random() * 10)) + Math.floor((Math.random() * 10)) + Math.floor((Math.random() * 10)), { shouldValidate: true })
      setGeneratingCode(false)
      setShowTooltip(true)
    }
    else if (name?.length < 3) {
      setValue('code', '', { shouldValidate: true })
      setShowTooltip(false)
    }
  }, [name, setValue, code])

  const onSubmit = (values) => {
    const allData = {
      ...values,
      ...data,
      department,
      badanUsaha,
      role: 'SUPERVISOR',
      logo: values.logo[0]
    }

    setLoading(true)
    authService.register(allData)
      .then(({ data: { user, company, accessToken, refreshToken } }) => {
        dispatch(authActions.loginRegister(user, company, accessToken, refreshToken));
      })
      .catch((err) => {
        addToast(err.response ? err.response.data.message : err.message, { appearance: 'danger' });
      })
      .finally(() => setLoading(false))
  }
  console.log(logo, name, title, code, isValid, agree)
  return (
    <>
      <h1 className="mb-16">Masukan nama perusahaan</h1>
      <p className="text-dark-gray">Silahkan masukan detail perusahaan anda</p>
      <div className={authStyles.formWrapper}>
        <form onSubmit={handleSubmit(onSubmit)} className={`${authStyles.form} ${styles.registerForm} ${styles.formStepSix}`}>
          <ImageField
            required
            className="mb-40"
            ref={register}
            name="logo"
          />
          <TextField
            className="mb-24"
            ref={register}
            name="name"
            label="Nama Perusahaan"
            error={errors.name?.message}
            helperText={errors.name?.message}
          />
           <SelectField
            // value={formOfBusinessEntity}
            onChange={v => setBadanUsaha(v.value)}
            options={[
              { label: 'PT', value: 'PT' }
            ]}
            label="Bentuk Badan Usaha"
            className="mb-24"
          />
           <SelectField
            // value={formOfBusinessEntity}
            onChange={v => setDepartment(v.value)}
            options={[
              {
                  "id": 1,
                  "value": "PERTANIAN",
                  "label": "Pertanian"
              },
              {
                  "id": 2,
                  "value": "OTOMOTIF",
                  "label": "Otomotif"
              },
              {
                  "id": 3,
                  "value": "PERBANKAN",
                  "label": "Perbankan"
              },
              {
                  "id": 4,
                  "value": "PASAR_MODAL",
                  "label": "Pasar Modal"
              },
              {
                  "id": 5,
                  "value": "KIMIA",
                  "label": "Kimia"
              },
              {
                  "id": 6,
                  "value": "KOSMETIK",
                  "label": "Kosmetik"
              },
              {
                  "id": 7,
                  "value": "KURSUS",
                  "label": "Kursus"
              },
              {
                  "id": 8,
                  "value": "PENDANAAN",
                  "label": "Crowdfunding/Donasi"
              },
              {
                  "id": 9,
                  "value": "BURSA_KRIPTO",
                  "label": "Pertukaran Kripto"
              },
              {
                  "id": 10,
                  "value": "JASA_EKOMERS",
                  "label": "Jasa/layanan e-commerce"
              },
              {
                  "id": 11,
                  "value": "PROP_EKOMERS",
                  "label": "Properti e-commerce"
              },
              {
                  "id": 12,
                  "value": "TRAVEL_EKOMERS",
                  "label": "Travel e-commerce"
              },
              {
                  "id": 13,
                  "value": "PEMBELIAN",
                  "label": "E-commerce/Marketplace"
              },
              {
                  "id": 14,
                  "value": "EDUTECH",
                  "label": "Pendidikan Teknologi (EduTech)"
              },
              {
                  "id": 15,
                  "value": "ELEKTRONIK",
                  "label": "Elektronik"
              },
              {
                  "id": 16,
                  "value": "EKSPEDISI",
                  "label": "Ekspedisi"
              },
              {
                  "id": 17,
                  "value": "FASHION",
                  "label": "Fashion"
              },
              {
                  "id": 18,
                  "value": "FMCG",
                  "label": "FMCG/CPG"
              },
              {
                  "id": 19,
                  "value": "MKN_MIN",
                  "label": "Makanan & Minuman (M&M)"
              },
              {
                  "id": 20,
                  "value": "PERABOT",
                  "label": "Perabotan"
              },
              {
                  "id": 21,
                  "value": "GAMING",
                  "label": "Gaming"
              },
              {
                  "id": 22,
                  "value": "GROSIRAN",
                  "label": "Grosir/Grocery Tech"
              },
              {
                  "id": 23,
                  "value": "TEKNOLOGI_KES",
                  "label": "Teknologi Kesehatan"
              },
              {
                  "id": 24,
                  "value": "RUMAH_SAKIT",
                  "label": "Rumah Sakit"
              },
              {
                  "id": 25,
                  "value": "HOTEL_GROUP",
                  "label": "Grup Hotel/Villa"
              },
              {
                  "id": 26,
                  "value": "HR_TECH",
                  "label": "Teknologi Sumber Daya Manusia (HRTech)"
              },
              {
                  "id": 27,
                  "value": "HUMAN_RESOURCE",
                  "label": "Sumber Daya Manusia/Outsourcing Gaji"
              },
              {
                  "id": 28,
                  "value": "INSURANCE",
                  "label": "Asuransi & Insur Tech"
              },
              {
                  "id": 29,
                  "value": "IT_SOLUTION",
                  "label": "Solusi TI"
              },
              {
                  "id": 30,
                  "value": "SERVICE_COOPERATION",
                  "label": "Koperasi Jasa"
              },
              {
                  "id": 31,
                  "value": "EMPOLYEE_COOPERATION",
                  "label": "Koperasi Pegawai"
              },
              {
                  "id": 32,
                  "value": "MULTIPURPOSE_COOPERATION",
                  "label": "Koperasi Serba Usaha"
              },
              {
                  "id": 33,
                  "value": "MULTIPURPOSE_COOPERATION",
                  "label": "Koperasi Serba Usaha"
              },
              {
                  "id": 34,
                  "value": "SAL_COOPERATION",
                  "label": "Koperasi Simpan Pinjam"
              },
              {
                  "id": 35,
                  "value": "SYARIA_SAL_COOPERATION",
                  "label": "Koperasi Simpan Pinjam Syariah"
              },
              {
                  "id": 36,
                  "value": "LABORATORIUM",
                  "label": "Laboratorium"
              },
              {
                  "id": 37,
                  "value": "LOGISTIC",
                  "label": "Logistik"
              },
              {
                  "id": 38,
                  "value": "MEDIA",
                  "label": "Media/PR/Periklanan/Event"
              },
              {
                  "id": 39,
                  "value": "MEDICAL_CLINIC",
                  "label": "Klinik Medis"
              },
              {
                  "id": 40,
                  "value": "MINING",
                  "label": "Pertambangan"
              },
              {
                  "id": 41,
                  "value": "MLM",
                  "label": "MLM"
              },
              {
                  "id": 42,
                  "value": "ONLINE_POS",
                  "label": "POS Online/Mobile"
              },
              {
                  "id": 43,
                  "value": "OUTSOURCING",
                  "label": "Outsourcing"
              },
              {
                  "id": 44,
                  "value": "PAYMENT",
                  "label": "Pembayaran/Pintu Gerbang Pembayaran/Remittance"
              },
              {
                  "id": 45,
                  "value": "PHARMACY",
                  "label": "Apotek"
              },
              {
                  "id": 46,
                  "value": "PPOB",
                  "label": "PPOB"
              },
              {
                  "id": 47,
                  "value": "PROPERTY",
                  "label": "Properti & Real Estate"
              },
              {
                  "id": 47,
                  "value": "PROPERTY",
                  "label": "Properti & Real Estat"
              },
              {
                  "id": 48,
                  "value": "SCHOOL",
                  "label": "Sekolah"
              },
              {
                  "id": 49,
                  "value": "SME_LENDING",
                  "label": "Pembiayaan UKM"
              },
              {
                  "id": 50,
                  "value": "SOCIAL_COMMERCE",
                  "label": "E-commerce Sosial"
              },
              {
                  "id": 51,
                  "value": "TEXTILE",
                  "label": "Tekstil & Garmen"
              },
              {
                  "id": 52,
                  "value": "TRANSPORTATION",
                  "label": "Transportasi"
              },
              {
                  "id": 53,
                  "value": "TRAVEL",
                  "label": "Travel"
              },
              {
                  "id": 54,
                  "value": "UNIVERSITY",
                  "label": "Universitas"
              },
              {
                  "id": 55,
                  "value": "RELIGIOUS_FOUNDATION",
                  "label": "Yayasan Keagamaan"
              },
              {
                  "id": 56,
                  "value": "HUMANITARIAN_FOUNDATION",
                  "label": "Yayasan Kemanusiaan"
              },
              {
                  "id": 57,
                  "value": "SOCIAL_FOUNDATION",
                  "label": "Yayasan Sosial"
              }
          ]}
            label="Industri"
            className="mb-24"
          />
          {/* <TextField
            className="mb-24"
            ref={register}
            name="department"
            label="Departemen Perusahaan"
            error={errors.department?.message}
            helperText={errors.department?.message}
          /> */}
          <TextField
            className="mb-24"
            ref={register}
            name="title"
            label="Jabatan"
            error={errors.title?.message}
            helperText={errors.title?.message}
          />
          <TextField
            disabled
            className="mb-32"
            style={{zIndex: 0}}
            label="Kode Perusahaan"
            value={code}
            loading={generatingCode}
            tooltip={(
              <p>
                Kode ini akan digunakan untuk masuk ke akun Piro.
                <br></br>
                Pastikan Anda ingat buat mudah diingat dan relevan.
              </p>
            )}
            popperPlacement={width <= 1152 ? 'bottom-start' : 'right-start'}
            showTooltip={showTooltip}
          />
           <Checkbox
            className="mb-32"
            color="primary"
            label={<>Saya mewakili perusahaan ini</>}
            checked={agree}
            onChange={e => setAgree(e.target.checked)}
          />
          <MainButton
            type="submit"
            disabled={!(logo && name && department && title && code && isValid && agree)}
          >
            Lanjutkan
          </MainButton>
        </form>
      </div>
    </>
  )
}

export default StepSix
